import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { GuiasApi } from '@/services/api-routes'
import { emptyPage } from '@/types/api'
import type { GuiaResumida, HistoricoGuiaEvento, ListarGuiasFiltro } from '@/types/guia'
import { guiasKeys } from '@/http/queryKeys'
import { defaultOptions, liveOptions } from '@/http/default-query-options'

export const useGuiasQuery = (filtro: ListarGuiasFiltro, enabled = true) =>
  useQuery({
    queryKey: guiasKeys.list(filtro),
    queryFn: async ({ signal }) =>
      (await GuiasApi.listar(filtro, signal)) ?? emptyPage<GuiaResumida>(),
    placeholderData: keepPreviousData,
    enabled,
    ...liveOptions,
  })

export const useGuiaQuery = (guiaId: string | undefined) =>
  useQuery({
    queryKey: guiasKeys.detail(guiaId ?? ''),
    queryFn: ({ signal }) => GuiasApi.obter(guiaId as string, signal),
    enabled: Boolean(guiaId),
    ...defaultOptions,
  })

export const useHistoricoGuiaQuery = (
  guiaId: string | undefined,
  pageNumber: number,
  pageSize: number,
  habilitada = true,
) =>
  useQuery({
    queryKey: guiasKeys.historico(guiaId ?? '', pageNumber, pageSize),
    queryFn: async ({ signal }) =>
      (await GuiasApi.historico(guiaId as string, pageNumber, pageSize, signal)) ??
      emptyPage<HistoricoGuiaEvento>(),
    placeholderData: keepPreviousData,
    enabled: Boolean(guiaId) && habilitada,
    ...liveOptions,
  })

export const usePayloadHistoricoGuiaQuery = (
  guiaId: string | undefined,
  logId: string | undefined,
) =>
  useQuery({
    queryKey: guiasKeys.payloadHistorico(guiaId ?? '', logId ?? ''),
    queryFn: ({ signal }) => GuiasApi.payloadHistorico(guiaId as string, logId as string, signal),
    enabled: Boolean(guiaId) && Boolean(logId),
    ...defaultOptions,
  })
